import { makeRequest } from 'services/request.service'

// Authenticated request to the /system/* API
export const systemRequest = (method, url, data = null) => makeRequest({
  method,
  url,
  data,
  headers: { Authorization: `Bearer ${localStorage.getItem('secret')}` }
})

export const getRequestErrorMessage = (error, fallback) => error?.response?.data?.message || fallback

export const getMissingFields = (formData, fields) =>
  fields.filter(field => formData[field] === undefined || formData[field] === null || String(formData[field]).trim() === '')
